export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const ECON_API_BASE_URL = process.env.REACT_APP_ECON_API_BASE_URL;
